import classNames from "classnames";
import { ButtonHTMLAttributes, FC, PropsWithChildren } from "react";
import { Glyph } from "../../types";
import styles from "./Button.module.css";
import Icon from "./Icon";

type Props = PropsWithChildren<{
  glyph?: Glyph;
  buttonProps?: ButtonHTMLAttributes<HTMLButtonElement>;
  type?: "primary" | "secondary" | "remove";
  maxWidth?: `${number}px`;
}>;

const Button: FC<Props> = ({ glyph, buttonProps, children, maxWidth, type = "primary" }: Props) => {
  return (
    <button
      type="button"
      {...buttonProps}
      style={{ ...buttonProps?.style, maxWidth: maxWidth }}
      className={classNames(styles.button, buttonProps?.className, {
        [styles.primary]: type == "primary",
        [styles.secondary]: type == "secondary",
        [styles.remove]: type == "remove",
      })}
    >
      {glyph && <Icon className={styles.icon} glyph={glyph} />}
      {!!children && <span className={styles.body}>{children}</span>}
    </button>
  );
};

export default Button;
